export const findBlockByName = (blockName, blocks) => { 
    if (!blocks || !Array.isArray(blocks)) {
        return null;
    }

    for (const block of blocks) {
        if (block.blockName === blockName) {
            return block;
        }

        if (block.innerBlocks && Array.isArray(block.innerBlocks) && block.innerBlocks.length > 0) {
            const foundBlock = findBlockByName(blockName, block.innerBlocks);
            if (foundBlock) {
                return foundBlock;
            }
        }
    }

    return null;
};